import { useMutation } from '@apollo/client';
import {
  ImportExternalProjectInput,
  ImportExternalProjectResponse,
} from '@provision/entity-types';
import { useCallback } from 'react';
import { IMPORT_PORTALIO_PROJECT } from 'src/graphql/entities/integrations/portalio/portalio.operations';
import { useGlobalStore } from 'src/store';
import { useNotifications } from 'src/utils/hooks';

type ImportPortalioProjectData = {
  importPortalioProject: ImportExternalProjectResponse<number>;
};

export const useImportPortalioProject = () => {
  const { showErrorAlert } = useNotifications();
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  const [importPortalioProjectMutation, importPortalioProjectResult] = useMutation<
    ImportPortalioProjectData,
    ImportExternalProjectInput<number>
  >(IMPORT_PORTALIO_PROJECT, {
    onError: (error) => {
      showErrorAlert(error.message);
    },
  });

  const importPortalioProject = useCallback(
    async (projectIds: number[]) => {
      if (selectedPartnerId === null) {
        return;
      }
      await importPortalioProjectMutation({
        variables: {
          params: {
            projectIds,
            partnerId: selectedPartnerId,
          },
        },
      });
    },
    [importPortalioProjectMutation, selectedPartnerId],
  );

  const importPayload = importPortalioProjectResult.data?.importPortalioProject;

  return {
    importPortalioProject,
    loading: importPortalioProjectResult.loading,
    records: importPayload?.records ?? [],
    errors: importPayload?.errors,
  };
};
